import t from "react";
import { getIconColor as i } from "./iconfont.es5470.js";
import s from "./iconfont.es5471.js";
const l = {
  display: "block"
}, x = ({ size: o = 16, useVw: e, useRem: n, color: r, withColor: a, removeClassName: m, disableSSR: d, style: c, ...p }) => {
  const h = c ? { ...l, ...c } : l;
  return /* @__PURE__ */ t.createElement(s, { disableSSR: d }, /* @__PURE__ */ t.createElement("svg", { "data-icon-id": "icon-24px-anheimoshiv31", "data-icon-group": "GateHeader", "data-icon-version": "0.8.1", viewBox: "0 0 24 24", width: e ? ((o || 0) / 375 * 100).toFixed(5) + "vw" : o + (n ? "rem" : "px"), height: e ? ((o || 0) / 375 * 100).toFixed(5) + "vw" : o + (n ? "rem" : "px"), className: m ? "" : "iconpark-icon", style: h, fill: "none", ...p }, /* @__PURE__ */ t.createElement(
    "path",
    {
      fill: a ? i(r, 0, "currentColor") : "currentColor",
      datafollowfill: a ? i(r, 0, "currentColor") : "currentColor",
      d: "M12.002 4h-.013a.662.662 0 0 0-.577.982c.385.702.598 1.51.588 2.37-.034 2.537-2.064 4.635-4.598 4.746a4.788 4.788 0 0 1-2.547-.597c-.382-.21-.855.052-.855.488V12a8.001 8.001 0 0 0 8.114 8c4.309-.06 7.825-3.576 7.885-7.885A7.998 7.998 0 0 0 12.002 4Z"
    }
  )));
}, C = x;
export {
  C as default
};
